/**
 * Mixin for login API endpoint calls
 */
export default {
    methods: {
        autoSubmit(id, length, submitHandler) {
            const verifyCodeInput = document.getElementById(id);
            if (verifyCodeInput.value.length >= length) {
                verifyCodeInput.blur();
                submitHandler();
            }
        },
    },
};
